import {  INCREMENT_COUNT, SET_USER_LOGIN } from '../constants/authenticationConstants';

export const incrementCount = () => ({
    type: INCREMENT_COUNT,
    data: null
  });
export const setUserLogin = () => ({
    type: SET_USER_LOGIN
  });
